import * as CategoryAssembler from 'src/domain/assemblers/CategoryAssembler.ts';
import * as ECAPI from './EcommerceService.ts';
import type { Categories, Category } from '@/domain/Category.ts';
import type { HierarchicalCategoryDTO } from '@/services/generated/ECAPIProductsDTOs.ts';
import type { Product } from '@/domain/Product.ts';

export type GroupedProductsByCollection = { [key: string]: Product[] };

export async function getCategories(
  market: string, // like 'es'
  channel: string, // like 'b2c'
  locale: string, // like 'en',
  cacheBurst?: boolean
): Promise<Categories> {
  const productCategories = await ECAPI.productCategories(
    market,
    channel,
    locale,
    cacheBurst
  );

  return transformCategoriesToMap(productCategories);
}

export function transformCategoriesToMap(
  productCategories: HierarchicalCategoryDTO[]
) {
  const categoriesMap: Categories = new Map<string, Category>();

  productCategories.forEach((productCategory) => {
    const category = CategoryAssembler.fromEcapiDto(
      productCategory,
      productCategories
    );
    categoriesMap.set(category.code, category);
  });

  return categoriesMap;
}
